export var percentChange = function (current, last) {
    return (current && last) !== 0 ? (current / last - 1) * 100 : 0;
};
